import _objectSpread from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import layoutHeaderAside from '@/layout/header-aside';

var _import = require('@/libs/util.import.' + process.env.NODE_ENV);

var meta = {
  auth: true
};
export default {
  path: '/deposit',
  name: 'deposit',
  meta: meta,
  component: layoutHeaderAside,
  children: [{
    path: 'index',
    name: 'deposit-index',
    component: _import('deposit/index.vue'),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      cache: true,
      title: '押金管理'
    }),
    props: true
  }]
};